module.exports = __webpack_public_path__ + "static/media/card5.d1aad4e9.png";